import React from "react";
import Script from "next/script";
import $ from 'jquery';
import { googleApiKey } from "../../utils/constants";


export const ThirdParty = () => {

  const initializeFB = () => {
    FB.init({
          appId: '191533927996140',
          cookie: true,
          xfbml: true,  // parse social plugins on this page
          version: 'v7.0' // use graph api version 2.8
      });
  };

  const initializeApple = function(){    
    AppleID.auth.init({
        clientId : 'com.stringssg.signin',
        scope : 'email name',
        redirectURI : 'https://www.stringssg.com',
        state : 'sign in',
        usePopup : true //or false defaults to false
    });
  }

    return (
      <>
        <Script 
          id="google-login-js"
          src="https://accounts.google.com/gsi/client"
          strategy="lazyOnload"
          onLoad={() => {              
              //initializeGoogleLogin();
          }} 
        />
        <Script
            id="google-maps"
            src={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&language=en&libraries=places`}
            // onLoad={() => {
            //     initMap()
            // }}
        />
        <Script 
          id="fb-login-js"
          src="//connect.facebook.net/en_US/sdk.js"
          strategy="lazyOnload"
          onLoad={() => {
              initializeFB();
          }}
        />
        <Script 
          id="apple-login-js"
          src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"
          strategy="lazyOnload"
          onLoad={() => {        
            $(".apple-signin").append("<div id='appleid-signin' data-color='black' data-border='true' data-type='sign in'></div>");      
              initializeApple();
              
          }} 
        />
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script 
          id="google-tagmanager-js"
          src="https://www.googletagmanager.com/gtag/js?id=AW-823304067"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'AW-823304067');
				  
            window.gtag = gtag;
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
      </>
    )
  }